import React from "react";
import { Grid } from "@material-ui/core";
import { FormStore } from "@modules/formx";
import { fixNumber } from "@bonliva-crm/common";
import locale from "@bonliva-crm/locale";
import { CurrencyText } from "@components/formx";
import { usePasteFromExcel, useSnackbars } from "@hooks";
import { isString, isArray } from "lodash";

type FormData = {
  EmployeeSalaryStr: string;
  AccommodationCostStr: string;
  TravelCostStr: string;
};

type Props<T extends FormData> = {
  form: FormStore<T>;
};

export function EmployeeCosts<T extends FormData>(props: Props<T>) {
  const { showInfo } = useSnackbars();

  const { onPaste } = usePasteFromExcel((values, e) => {
    if (values.length === 1) {
      props.form.setValue((e as any).target.name, fixNumber(values[0]));
      // return props.form.setValue("EmployeeSalaryStr", fixNumber(values[0].toString()));
    }

    if (isArray(values) && values.length === 3) {
      props.form.setValue("EmployeeSalaryStr", fixNumber(values[0].toString()));
      props.form.setValue("TravelCostStr", fixNumber(values[1].toString()));
      props.form.setValue("AccommodationCostStr", fixNumber(values[2].toString()));
      return;
    }

    if (isString(values)) {
      props.form.setValue((e as any).target.name, fixNumber(values));
      return;
    }

    return showInfo("Expected 3 numbers: salary, travel cost, accommodation cost");
  });

  return (
    <React.Fragment>
      <Grid item>
        <CurrencyText
          name="EmployeeSalaryStr"
          label={locale.bookingFinance.EmployeeSalary}
          TextFieldProps={{
            fullWidth: true,
            onPaste
          }}
        />
      </Grid>

      <Grid item>
        <CurrencyText
          name="TravelCostStr"
          label={locale.bookingFinance.travelCost}
          TextFieldProps={{ fullWidth: true, onPaste, style: { marginTop: 8 } }}
        />

        <Grid item>
          <CurrencyText
            name="AccommodationCostStr"
            label={locale.bookingFinance.accommodationCost}
            TextFieldProps={{ fullWidth: true, onPaste, style: { marginTop: 8 } }}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
